import type {CardSummary} from '../../../types/card-summary'
import {buildCustomerSummary} from '../../../types/customer-summary'

const normalizeCustomerSummary = function (input: Object): CardSummary {
  return {
    ...buildCustomerSummary,
    id: input.id,
    gender: input.gender,
    firstName: input.firstName,
    surnamePrefix: input.surnamePrefix,
    surname: input.surname,
    dateOfBirth: input.dateOfBirth ? new Date(input.dateOfBirth) : null
  }
}

export {
  normalizeCustomerSummary
}



// WEBPACK FOOTER //
// ./src/services/b2b/normalizer/customer-summary-normalizer.js